import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Spinner, Card } from 'react-bootstrap';
import { fetchSpacesData } from '../services/SpacesApi';
import ErrorMessage from '../components/ErrorMessage';
import PieChartComponent from '../components/PieChartComponent';
import BarChartComponent from '../components/BarChartComponent';
import { formatPieChartData, formatBarChartData } from '../services/dataFormatter';

const GroupStudyRoomsPage = ({ startDate, endDate, loading, error, setError, setLoading }) => {
  const [spacesResponse, setSpacesResponse] = useState(null);

  const loadData = async () => {
    if (!startDate || !endDate) return;

    setLoading(true);
    setError(null);
    try {
      const data = await fetchSpacesData(startDate, endDate);
      setSpacesResponse(data);
    } catch (err) {
      setError('Error loading group study room data.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  return (
    <div>
      <Container className="mt-5">
        {loading && (
          <Row className="justify-content-center">
            <Col xs="auto">
              <Spinner animation="border" role="status" />
              <span className="ms-2">Loading...</span>
            </Col>
          </Row>
        )}

        {error && (
          <Row className="justify-content-center">
            <Col xs="auto">
              <ErrorMessage message={error} />
            </Col>
          </Row>
        )}

        {spacesResponse && (
          <>
            <Row>
            <Col md={6} xs={12} className="mx-auto">
              <Card className="collection-box h-100 text-center">
                <Card.Body>
                  <Card.Title className="collection-title">Total bookings</Card.Title>
                  <Card.Text className="collection-value">{spacesResponse.totalBookings}</Card.Text>
                </Card.Body>
              </Card>
              </Col>

              <Col md={6} xs={12} className="mx-auto">
              <Card className="collection-box h-100 text-center">
                <Card.Body>
                  <Card.Title className="collection-title">Total Hours Booked</Card.Title>
                  <Card.Text className="collection-value">{Math.round(spacesResponse.totalHours * 10) / 10}</Card.Text>
                </Card.Body>
              </Card>
              </Col>

            </Row>
            <Row className="mb-4">
              <Col md={6} xs={12} className="mx-auto">
                <PieChartComponent data={formatPieChartData(spacesResponse.bookingsByWeekday, 'Bookings by Weekday')} />
              </Col>

              <Col md={6} xs={12} className="mx-auto">
                <PieChartComponent data={formatPieChartData(spacesResponse.usageByRoom, 'Usage by Room (Total Hours)')} />
              </Col>
            </Row>

            <Row className="mb-4">
              <Col md={8} xs={12} className="mx-auto">
                <BarChartComponent data={formatBarChartData(spacesResponse.bookingsPerMonth, 'Bookings per Month')} />
              </Col>
            </Row>
          </>
        )}
      </Container>
    </div>
  );
};

export default GroupStudyRoomsPage;
